export default __webpack_public_path__ + "static/media/MinerMk2.256.b690fdd2.png";